<template>
  <v-dialog
    v-model="show"
    max-width="40vw"
    @click:outside="cancel"
  >
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card-title class="justify-center text-h5">
        {{ label }}
      </v-card-title>
      <v-card-text>
        <v-form class="multi-col-validation mt-6" ref="form">
          <v-row>
            <v-col
              md="6"
              cols="12"
            >
              <v-text-field
                v-model="name"
                label="Наименование"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="sex"
                :items="sexDropdown"
                :menu-props="{ maxHeight: '400' }"
                label="Пол"
                dense
                outlined
                persistent-hint
                hide-details
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="ageFrom"
                label="Возраст c"
                dense
                outlined
                :rules="rules.integerValidator"
              ></v-text-field>

              <v-text-field
                v-model="ageTo"
                label="Возраст по"
                dense
                outlined
                :rules="rules.integerValidator"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <date-picker
                v-model="dateOfBirth"
                label="Дата рождения"
              ></date-picker>
            </v-col>

            <v-col cols="12">
              <v-btn
                @click="saveData"
                color="primary"
                class="me-3 mt-4"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                type="reset"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js'
import { mapFormHandlers } from '@/helpers/forms'
import { mapActions, mapGetters } from 'vuex'
import DatePicker from '@/components/date-picker'
import { rules } from '@/helpers/validation'

export default {
  name: 'GroupCriteriaForm',
  components: { DatePicker },
  props: ['save', 'show', 'cancellation', 'label'],
  data: () => ({
    icons: {
      mdiCheck,
      mdiClose,
    },
    rules,
  }),
  computed: {
    ...mapFormHandlers('groupCriteria/form', [
      'name',
      'sex',
      'ageFrom',
      'ageTo',
      'dateOfBirth',
    ]),
    ...mapGetters('dictionary', { sexDropdown: 'sexDropdown' }),
  },
  async mounted() {
    await this.fetchSex()
  },
  watch: {
    show: function(newValue) {
      if (newValue && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
  },
  methods: {
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    ...mapActions('groupCriteria/form', ['resetForm']),
    ...mapActions('dictionary', { fetchSex: 'fetchSex' }),
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.save()
        this.resetForm()
      }
    },
  },
}
</script>
